import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .link {
      display: flex;
      align-items: center;
      background-color: #F6F6F6;
      border: 1px solid rgb(200, 200, 200);
      padding: 7.5px 15px;
      border-radius: 5px;
      font-size: 16px;
      color: #777;
      cursor: pointer;
      white-space: nowrap;

      span {
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }
      svg {
         margin-right: 7.5px;
      }
      &:hover {
         text-decoration: underline;
      }
   }
   .flex {
      display: flex;
      align-items: center;
      margin-bottom: 7.5px;
   }
   .status {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #F6F6F6;
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;
      padding: 7.5px 15px;
      font-size: 15px;
      height: 35px;
      margin-top: 10px;

      &.memory {
         width: 100%;
         margin-right: 7.5px;
      }
      &.remove {
         color: #E02424;
         width: 45px;
         min-width: 45px;
         transition: all .2s ease-in-out;
         cursor: pointer;

         &:hover {
            background-color: #E02424;
            color: #fff;
         }
      }
      > div {
         display: flex;
         justify-content: center;
         align-items: center;
         width: 150px;
         margin-bottom: 3px;

         &:not(:last-of-type) {
            margin-bottom: 7.5px;
         }
         span:first-of-type {
            width: 10px;
            height: 10px;
            background-color: #339966;
            margin-right: 7.5px;
            border-radius: 2px;
            box-shadow: 0 0 3px #339966;
         }
         span:last-of-type {
            opacity: 0.85;
         }
      }
      .empty {
         opacity: 0.8;
         text-align: center;
      }
   }
   .textInput {
      margin-top: 10px;

      h4 {
         width: 55px;
      }
   }
   .addExtractor {
      margin: auto;
      width: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      color: #fff;
      height: 33px;
      border-radius: 5px;
      font-size: 15px;
      padding: 0 15px;
      cursor: pointer;
      transition: all .2s ease-in-out;

      &.disabled {
         pointer-events: none;
         opacity: 0.65;
      }
      span {
         margin-left: 7.5px;
      }
      &:hover {
         opacity: 0.9;
      }
   }
   .extractor {
      display: flex;
      margin-top: 10px;

      .textInput {
         width: 100%;
         margin-top: 0;
      }
      .remove {
         display: flex;
         align-items: center;
         justify-content: center;
         background-color: #F6F6F6;
         border: 1px solid rgb(220, 220, 220);
         border-radius: 5px;
         min-width: 40.2px;
         width: 40.2px;
         margin-left: 7.5px;
         cursor: pointer;
         
         svg {
            opacity: 0.5;
            transition: all .2s ease-in-out;
         }
         &:hover svg {
            opacity: 1;
         }
      }
   }
`;